import { render, staticRenderFns } from "./person.vue?vue&type=template&id=552366ba&scoped=true&"
import script from "./person.vue?vue&type=script&lang=js&"
export * from "./person.vue?vue&type=script&lang=js&"
import style0 from "./person.vue?vue&type=style&index=0&lang=css&"
import style1 from "./person.vue?vue&type=style&index=1&id=552366ba&scoped=true&lang=css&"
import style2 from "./person.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552366ba",
  null
  
)

export default component.exports